import { storageAPI } from '@cutwise/utils';

import { KEY_TOKEN, KEY_URI_AFTER_AUTH } from '@/dmdrive/core/constants/storage';

export class AuthService {
  static clearAuthData() {
    storageAPI.remove(KEY_TOKEN);
  }

  static redirectToLogin() {
    AuthService.clearAuthData();
    storageAPI.set(KEY_URI_AFTER_AUTH, window.location.href);

    const domain = process.env.DMCLOUD_AUTH_DOMAIN;
    const clientId = process.env.DMCLOUD_AUTH_CLIENT_ID;
    const redirectUri = process.env.DMCLOUD_REDIRECT_URI;
    const authUri = `${domain}/api/oauth/v2/auth`;
    const authQueryString = `client_id=${clientId}&response_type=token&grant_type=token&redirect_uri=${redirectUri}`;

    window.location.href = `${authUri}?${authQueryString}`;
  }
}
